import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {listSettings, updateSettings} from "../actions/settingsActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import {Button, Col, Form, InputGroup, Row} from "react-bootstrap";
import Select from "react-select";
import {listMedia} from "../actions/mediaActions";
import {logout} from "../actions/userActions";
import {SETTINGS_UPDATE_DETAILS_RESET} from "../constants/settingsConstants";

const SettingsScreen = ({history, language, t}) => {
    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const settings = useSelector((state) => state.settingsList);
    const {settingsList, error, loading} = settings;
    const [streams, setStreams] = useState([]);
    const [closings, setClosings] = useState([]);
    const announcementsList = useSelector(state => state.announcementList);
    const {loading: announcementsLoading, error: announcementsError, announcementList} = announcementsList;
    const [announcementOptions, setAnnouncementOptions] = useState([]);

    const settingsUpdate = useSelector((state) =>  state.settingsUpdate);
    const {loading: settingsUpdateLoading, settingsList: settingsUpdateList, error: settingsUpdateError, success} = settingsUpdate;

    useEffect(()=>{
        dispatch(listMedia('announcements'));
    },[]);

    useEffect(()=>{
        if(announcementList){
            const idk = announcementList.map(element => {
                element.label = element.name;
                element.value = element._id;
                return element;
            });
            setAnnouncementOptions(idk);
        }
    }, [dispatch, announcementList]);

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [history, userInfo]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error, dispatch]);

    useEffect(()=>{
        if(userInfo) {
            dispatch({type: SETTINGS_UPDATE_DETAILS_RESET});
            dispatch(listSettings(userInfo._id));
        }
    },[dispatch, userInfo]);

    useEffect(() => {
        dispatch({type: SETTINGS_UPDATE_DETAILS_RESET});
    }, []);

    useEffect(() => {
        if(settingsList && announcementsList){
           setClosings(settingsList.closings.map(element => {
               element.announcement.label = element.announcement.name;
               element.announcement.value = element.announcement._id;
               return element;
           }));
           setStreams(settingsList.streams);
        }
    },[dispatch,settingsList, announcementList]);

/*    const addStream = () => {
        setStreams(prevState => {
            const idk = [...prevState];
            idk[idk.length] = {url: '', selected: false};
            return idk;
        });
    }*/

    const addClosing = () => {
        setClosings(prevState => {
            const idk = [...prevState];
            idk[idk.length] = {minutesBeforeClosing: 10, announcement: null};
            return idk;
        })
    }

    const submitSettings = (e) => {
        e.preventDefault();
        console.log(closings);
        settingsList.closings = closings;
        console.log(settingsList);
        dispatch(updateSettings(userInfo._id, settingsList));
    }

    return (
        <div>
            <h1 className={'text-center'}>{t('settings_general_settings_title')}</h1>
            <h2 className={'mt-4'}>{t('settings_general_closing')} - <Button onClick={addClosing} variant='info' className={'mb-1'} disabled={loading || error !== undefined}>{t('settings_add_general_closing')}</Button></h2>
            { loading ? (<Loader />) : error ? (<Message variant='danger'>{error}</Message>) : (
                <div>
                    <Form onSubmit={submitSettings}>
                        {/*<h1>Streamek - <Button onClick={addStream} variant='info' className={'mb-1'}>Stream hozzáadása</Button></h1>

                        {streams?.map(stream => <div>
                            <p>hi</p>
                        </div>)}*/}


                        {closings.map((closing, index) => <div>
                            <Form.Group className='mb-4' key={index}>
                                <Form.Label>{t('settings_before_general_closing')}:</Form.Label>
                                <Row className={'align-items-center'}>
                                    <Col md={3}>
                                        <InputGroup>
                                            <Form.Control type='number' value={closings[index].minutesBeforeClosing} onChange={(e) => {
                                                setClosings(previousClosings => {
                                                    const idk = [...previousClosings];
                                                    idk[index].minutesBeforeClosing = e.target.valueAsNumber;
                                                    return idk;
                                                })
                                            }}/>
                                            <InputGroup.Append>
                                                <InputGroup.Text>{t('settings_general_closing_minutes')}</InputGroup.Text>
                                            </InputGroup.Append>

                                        </InputGroup>

                                    </Col>
                                    <Col md={7} className='m-auto'>
                                        <Select id='maksi' key='kaksi' isSearchable isClearable
                                                placeholder={t('settings_general_closing_select_description')} options={announcementOptions}
                                                onChange={(announcementFromSelect) => {
                                                    setClosings(previousClosings => {
                                                        const idk = [...previousClosings];
                                                        idk[index].announcement = announcementFromSelect;

                                                        return idk;
                                                    })
                                                }} value={closings[index].announcement}/>
                                    </Col>
                                    <Col md={2}>
                                        <Button size={'sm'} variant='danger' onClick={() => {
                                            setClosings(previousClosings => {
                                                const idk = [...previousClosings];
                                                idk.splice(index,1);
                                                return idk;
                                            })
                                        }}>X</Button>
                                    </Col>
                                </Row>
                            </Form.Group>
                        </div>)}
                        <div className={'mt-5 text-center mb-3'}><Button type='submit' variant='success'>{t('button_save')}</Button></div>
                        {settingsUpdateLoading ? (<Loader />) :
                            (settingsUpdateError ? (<Message variant={'danger'}>{settingsUpdateError}</Message> ) :
                                (success ? (<Message variant={'success'}>{t('settings_saved')}</Message>) : (<div></div>)))}
                    </Form>

                </div>
            )}
        </div>
    );
};

export default SettingsScreen;
